import { ArrowLeft } from 'lucide-react';
import { Logo } from '../Logo';
import { Footer } from '../Footer';

export default function CookiePage() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white">
      <nav className="sticky top-0 z-50 bg-[#0A0A0B]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><Logo /></a>
          <a href="/" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"><ArrowLeft className="w-4 h-4" />Back to Home</a>
        </div>
      </nav>
      <main className="max-w-3xl mx-auto px-6 md:px-8 py-20">
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit mb-2">Cookie Policy</h1>
        <p className="text-sm text-zinc-500 mb-12">Last updated: March 28, 2026</p>

        <div className="space-y-8">
          <Section title="1. What Are Cookies">
            Cookies are small text files stored on your device when you visit a website. They help us provide essential functionality and improve your experience.
          </Section>
          <Section title="2. Cookies We Use">
            <strong>Essential Cookies:</strong> Required for authentication, session management, and security. These cannot be disabled without breaking core functionality.<br /><br />
            <strong>Functional Cookies:</strong> Remember your preferences such as theme settings and dashboard layout. These improve your experience but are not strictly necessary.<br /><br />
            <strong>Analytics Cookies:</strong> We collect anonymous usage data to understand how the platform is used and to improve performance. No advertising cookies are used.
          </Section>
          <Section title="3. Third-Party Cookies">
            We do not use third-party advertising or tracking cookies. Our third-party service providers (hosting, email delivery) may set technical cookies required for their services.
          </Section>
          <Section title="4. Managing Cookies">
            You can manage cookies through your browser settings. Disabling essential cookies may prevent you from using certain features of D3 Command. Most browsers allow you to: view cookies stored on your device; delete individual or all cookies; block cookies from specific sites; and block all third-party cookies.
          </Section>
          <Section title="5. Cookie Retention">
            Session cookies are deleted when you close your browser. Authentication tokens expire after 24 hours. Preference cookies may persist for up to 1 year.
          </Section>
          <Section title="6. Updates to This Policy">
            We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated revision date.
          </Section>
          <Section title="7. Contact">
            For questions about our use of cookies, contact us at <a href="mailto:support@d3command.com" className="text-indigo-400 hover:text-indigo-300">support@d3command.com</a>.
          </Section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-3">{title}</h2>
      <p className="text-sm text-zinc-400 leading-relaxed">{children}</p>
    </div>
  );
}
